/*====== import  ======*/
/*------ React ------*/
import React, { useState } from "react"
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
// import { screenMaster } from "03CommonApiParts/CodeDefinition";
/*------ CSS ------*/
import styled from 'styled-components';
/*------ Component Js/Jsx ------*/
import { SnackBar } from "../../../02CommonUiParts/MessageParts/SnackBar";
import { LeftTitleTableInputField } from "02CommonUiParts/TableParts/TableInputField";
// import { PASSVALUE_STORAGE, PATH_STORAGE } from "03CommonApiParts/CodeDefinition";
// import { useProvideData } from "03CommonApiParts/use-context";
/*====== Styles  ======*/
/*------ Styled Components ------*/
const Sdiv = styled.div`
    position: fixed;
    top: calc(50vh - 180px);
    left: calc(50vw - 160px);
`;
const SdivLoginWrapper = styled.div`
    text-align: left;
    border: 1px solid #5fa8c3;
    background-color: white;
    border-radius: 5px;
    /* width: 300px; */
    color: white;
    height: 200px;
`;
const SdivCont = styled.div`
    display: flex;
    margin: 0px auto;
    /* width: 172px; */
    justify-content: center;
    align-items: center;
    padding-top: 20px;
`;
const SdivWrapper = styled.div`
    margin: 0px 20px;
`
/*====== global variables ======*/
// const base64Swicth = true;	//エンコードデコード制御用
/*====== global functions ======*/


/* --------------------------- */
/* ---------- main ---------- */
/* --------------------------- */
export const GetAuthXX = () =>{ //認証・認可
    
    /* --------------------------- */
    /* -------- instance  -------- */
    /* --------------------------- */
    const navigate = useNavigate();//画面遷移用
    // const apiData = useProvideData();	//APIデータ取得

    /* --------------------------- */
    /* ---------- state ---------- */
    /* --------------------------- */
    const [snackbarMessage, setSnackbarMessage] = useState({ //スナックバー表示用
        open:false,
    });
    // const [progress, setProgress] = useState(false); //プログレスバー表示用
    /* --------------------------- */
    /* ----- reack-hook-form ----- */
    /* --------------------------- */
	const { register, handleSubmit, getValues, formState: { errors } } = useForm({
		mode: 'onSubmit',
		reValidateMode: 'onChange',
		shouldUseNativeValidation: false,
		shouldUnregister: false,
	});
    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */
    /* Reactメモリから値渡しの情報取得 */
    // const storageToken = sessionStorage.getItem(PASSVALUE_STORAGE);
    // var passValue = JSON.parse(storageToken);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    // /* Reactメモリから遷移情報取得 */
    // const pathToken = sessionStorage.getItem(PATH_STORAGE);
    // var pathValue = JSON.parse(pathToken);//JSON 文字列を取得し、JavaScriptオブジェクトに変換
    /*-------- 認証情報 --------*/ 
    const auth = {
        id: 'hrdb2022', pass: 'slrT+tq1'
    };
    /*------- urlからパラメータ取得 ------*/
    // var url = new URL(window.location.href);
    // const params = url.searchParams;
    // var authInfo;
    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
    /*-------- ボタン押下時 --------*/ 
    const onClickButton = () =>{
        // console.log(getValues('payload'))
        const id = getValues('payload.id')
        const pass = getValues('payload.pass')
        // const account = getValues('payload.account')

        if(id === auth.id && pass === auth.pass){
           navigate('/employee/information/list')
        }
    }
    
    
    return(
        <>
            <SnackBar
                content={snackbarMessage}
                set={setSnackbarMessage}/> 
            <form onSubmit={handleSubmit(onClickButton())}>
                <Sdiv>
                    <SdivLoginWrapper>
                        <SdivWrapper>
                            <SdivCont>
                                <LeftTitleTableInputField
                                    register={register('payload.id',{
                                        required:true
                                    })}
                                    error={errors}
                                    width='270px'
                                    name=''
                                    require={true}
                                    maxLength={64}
                                    pattern=''
                                    // value={employeeInfomation.number}//
                                />
                            </SdivCont>
                            <SdivCont>
                                <LeftTitleTableInputField
                                    type='password'
                                    register={register('payload.pass',{
                                        required:true
                                    })}
                                    error={errors}
                                    width='270px'
                                    maxLength={64}
                                    // value={employeeInfomation.number}//
                                />
                            </SdivCont>
                            {/* <SdivCont>
                                <InputSearchFieldA 
                                    id='accout'
                                    label='アカウント'
                                    placeholder='メールアカウントを記入'
                                    width='270px'
                                    pattern='code'
                                    register={register('payload.account',{
                                        required:true
                                    })}
                                />
                            </SdivCont> */}
                            <SdivCont>
                                <button style={{width: '285px', height:'30px',backgroundColor: '#5fa8c3', border: 'none'}}
                                type='submit'/>
                            </SdivCont>
                        </SdivWrapper>
                    </SdivLoginWrapper>
                </Sdiv>
            </form>
        </>
    );
}

